module.exports = __webpack_public_path__ + "img/bg2.33986a55.jpg";